export default "__VITE_ASSET__CayddBjb__"